import { t } from '../../utils/i18n'
import { useResendInvitation } from '../../utils/hooks/useResendInvitation'

interface PendingInvitationContentProps {
  email: string
  invitationOrganization?: string
  onResendSuccess?: () => void
  onSecondaryAction?: () => void
  secondaryButtonText?: string
  buttonStyles?: {
    primaryButton: string
    secondaryButton: string
  }
}

const PendingInvitationContent: React.FC<PendingInvitationContentProps> = ({
  email,
  invitationOrganization,
  onResendSuccess,
  onSecondaryAction,
  secondaryButtonText = t(
    'No, I would like to create an account with my own separate subscription'
  ),
  buttonStyles
}) => {
  const { handleResendInvite, isResending } = useResendInvitation({
    onSuccess: onResendSuccess
  })

  const onResendClick = () => {
    handleResendInvite(email)
  }

  return (
    <div style={{ textAlign: 'center', padding: '20px 0' }}>
      <h2
        style={{ fontSize: '24px', marginBottom: '20px', fontWeight: 'bold' }}
      >
        {t('Team Invitation Pending')}
      </h2>

      <p style={{ marginBottom: '20px', fontSize: '16px' }}>
        {invitationOrganization ? (
          <>
            {t("You've been invited to join")}{' '}
            <strong style={{ color: 'white' }}>{invitationOrganization}</strong>
            {t("'s team")}
          </>
        ) : (
          t("You've been invited to join a team")
        )}
      </p>

      <p style={{ marginBottom: '30px', fontSize: '14px', opacity: 0.9 }}>
        {t(
          'Please click the button below to join this team and create your account'
        )}
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          width: '100%',
          alignItems: 'center'
        }}
      >
        <button
          type="button"
          className={buttonStyles?.primaryButton || ''}
          onClick={onResendClick}
          disabled={isResending}
          style={{ width: '100%' }}
        >
          <span>
            {isResending ? t('Resending...') : t('Resend Email Invitation')}
          </span>
        </button>

        {onSecondaryAction && (
          <a
            onClick={(e) => {
              e.preventDefault()
              onSecondaryAction()
            }}
            style={{
              color: 'white',
              textDecoration: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#e728ea'
              e.currentTarget.style.textDecoration = 'underline'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'white'
              e.currentTarget.style.textDecoration = 'none'
            }}
          >
            {secondaryButtonText}
          </a>
        )}
      </div>
    </div>
  )
}

export default PendingInvitationContent
